<div class="container-fluid h-100">
  <div class="row h-100 ">
    <div class="col-auto bg-white h-100">
      <Sidebar ref="sidebar"></Sidebar>
    </div>
    <div class="col bg-white h-100 m-0">
      <Navbar @toggle-sidebar="toggleSidebar"></Navbar>
      <div class="bg-gray px-4 py-1 h-100">
        <div class="card bg-white shadow-sm mt-5 rounded-5 border-0">
          <div class="card-header bg-white border-0 rounded-5">
            <ul class="pills-billing-tab nav nav-pills mb-3" id="pills-billib-tab" role="tablist">
              <li class="nav-item text-sm" role="presentation">
              </li>
            </ul>
          </div>
          <div class="card-body">
            <div class="tab-content" id="pills-tabContent">
              
              <!-- Top Loans Info -->
              <div class="tab-pane fade show active" id="top_loans_info" role="tabpanel" aria-labelledby="top_loans_tab">
                <button class="btn btn-primary text-xs rounded-3 shadow mb-3" @click="open_create_segment">
                  <i class="bi bi-plus-lg"></i> Create Segment
                </button>
              
                <div class="table-responsive overflow-auto" style="max-height: 500px;">
                  <table class="table table-borderless table-striped table-hover align-middle mb-0 text-xs">
                    <thead class="text-white text-uppercase bg-dark sticky-top text-xxs">
                      <tr>
                        <th class="text-center"></th>
                        <th class="text-center">Segment Title</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </thead>
              
                    <tbody>
                      <tr v-for="(topic, index) in topics" :key="index" class="border-bottom">
                        <td class="text-center">
                          <span class="badge rounded-pill bg-primary text-white fw-normal px-2 py-1 small">
                            {{ index + 1 }}
                          </span>
                        </td>
              
                        <td class="text-center">{{ topic.name }}</td>
              
                        <td class="text-center">
                          <div class="d-flex justify-content-center gap-1">
                            <router-link :to="{ name: 'view_topic', params: { topic_id: topic.id } }">
                              <button class="btn btn-light btn-sm rounded-3 text-primary border">
                                View
                              </button>
                            </router-link>
              
                            <button
                              class="btn btn-light btn-sm rounded-3 text-success border"
                              @click="open_edit_segment(topic)"
                            >
                              Edit
                            </button>
              
                            <button
                              class="btn btn-light btn-sm rounded-3 text-danger border shadow-sm"
                              @click="delete_segment(topic.id)"
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              
          
              <!-- Consolidation Loan Info -->
              <div class="tab-pane fade" id="consolidation_loan_info" role="tabpanel" aria-labelledby="consolidation_loan_tab">
                <button class="btn btn-primary text-xs rounded-3 shadow mb-3" data-bs-toggle="modal" data-bs-target="#create_hub">
                  <i class="bi bi-plus-lg"></i> Create Your Voice
                </button>
                <div class="table-responsive table-scroll">
                  <table class="table table-bordered table-hover align-middle mb-0 text-xs">
                    <thead class="text-secondary text-uppercase bg-light sticky-top text-xxs">
                      <tr>
                        <th class="text-center">#</th>
                        <th>Your Voice</th>
                        <th>Date Created</th>
                        <th>Created By</th>
                        <th class="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(exchange_hub, index) in exchange_hubs" :key="exchange_hub.id" class="border-bottom">
                        <td class="text-center">
                          <span class="badge rounded-pill bg-primary text-white fw-normal px-2 py-1 small">
                            {{ index + 1 }}
                          </span>
                        </td>
                        <td>{{ exchange_hub.name }}</td>
                        <td>{{ exchange_hub.publication_date }}</td>
                        <td>{{ exchange_hub.creater.first_name }} {{ exchange_hub.creater.last_name }}</td>
                        <td class="text-center">
                          <button @click="delete_exchange_hub(exchange_hub.id)"
                            class="btn btn-light btn-sm rounded-3 text-danger border shadow-sm">
                            <i class="bi bi-trash"></i> Delete
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
          
            </div>
          </div>
          

          <div class="modal fade" id="segment_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <p class="modal-title text-xs fw-500" id="exampleModalLabel">
                    {{ editing ? 'Edit Segment' : 'Create a Segment' }}
                  </p>
                  <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
          
                <form @submit.prevent="submitSegment">
                  <div class="modal-body">
                    <div class="mb-3">
                      <label for="topic_name" class="form-label text-xs fw-500">
                        Segment Name <span class="text-danger">*</span>
                      </label>
                      <input type="text" class="form-control rounded-5 text-xs" id="topic_name" placeholder="Enter segment name"
                        v-model="topic_name">
                      <p v-if="errors.topic_name" class="text-danger text-xs">{{ errors.topic_name }}</p>
                    </div>
                  </div>
          
                  <div class="modal-footer">
                    <button type="submit" class="btn btn-primary text-xs rounded-5">
                      {{ editing ? 'Update' : 'Post' }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          

        </div>
       </div> 
    </div>
  </div>
</div> 
